import { pluralizeWithCount } from "@common/helpers/string";
import type { AgentUsageMonth } from "@common/schemas/domains/agentRuns/agent-usage.schema";
import {
    type DensityChartDay,
    type DensityChartPeriod,
    type DensityChartPeriodLabel,
    type DensityChartSeries,
    formatDensityRange,
} from "@design-system/DensityChart/DensityChart.lib";

export const FREE_SERIES_ID = "free";
export const PAID_SERIES_ID = "paid";

/** Stack order, bottom first: free tokens in Kick's color, paid in people's. */
export const USAGE_SERIES: DensityChartSeries[] = [
    {
        id: FREE_SERIES_ID,
        label: "Free tokens",
        color: "var(--chart-series-kick)",
        accentColor: "var(--chart-series-kick-accent)",
        selectedColor: "var(--chart-series-kick-selected)",
        hoverColor: "var(--chart-series-kick-hover)",
    },
    {
        id: PAID_SERIES_ID,
        label: "Paid tokens",
        color: "var(--chart-series-people)",
        accentColor: "var(--chart-series-people-accent)",
        selectedColor: "var(--chart-series-people-selected)",
        hoverColor: "var(--chart-series-people-hover)",
    },
];

export const toUsageChartDays = (
    months: readonly AgentUsageMonth[],
): DensityChartDay[] =>
    months.map((month) => ({
        date: month.month,
        values: {
            [FREE_SERIES_ID]: month.freeTokens,
            [PAID_SERIES_ID]: month.paidTokens,
        },
    }));

const monthIndex = (dateOnly: string) =>
    Number(dateOnly.slice(0, 4)) * 12 + Number(dateOnly.slice(5, 7));

/** Periods read like "Mar 2026 – May 2026" and "3 months". */
export function formatUsagePeriod(
    period: DensityChartPeriod,
): DensityChartPeriodLabel {
    return {
        range: formatDensityRange(period),
        duration: pluralizeWithCount(
            "month",
            monthIndex(period.end) - monthIndex(period.start) + 1,
        ),
    };
}
